function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 0h1440v332H0z"
}), React.createElement("linearGradient", {
  id: "b",
  x1: "4.398%",
  x2: "96.638%",
  y1: "50%",
  y2: "50%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F8FFFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#00C1F1"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 -15)"
}, React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  fillRule: "nonzero",
  stroke: "url(#b)",
  d: "M1440 0c-17.824 57.55-166.777 132.845-446.86 225.884C713.055 318.922 379.342 329.294-8 257",
  mask: "url(#c)",
  opacity: 0.346,
  transform: "matrix(-1 0 0 1 1432 0)"
}));

var SvgHowItWorksBottom = function SvgHowItWorksBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1440 290",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHowItWorksBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/how-it-works-bottom.0391cc01.svg";
export { ForwardRef as ReactComponent };